"use client";

import { AnimatePresence } from "motion/react";
import * as m from "motion/react-m";

export function FooterMessage({ error, defaultMessage }: { error: string | null; defaultMessage: string }) {
  return (
    <AnimatePresence mode='wait' initial={false}>
      {error ? (
        <m.p
          key='error'
          initial={{ opacity: 0, y: -8 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: 8 }}
          transition={{ duration: 0.2 }}
          className='tw-text-center tw-mx-auto tw-max-w-md tw-text-sm tw-leading-snug tw-text-red-700 tw-h-[3lh]'
        >
          {error}
        </m.p>
      ) : (
        <m.p
          key='default'
          initial={{ opacity: 0, y: 8 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: -8 }}
          transition={{ duration: 0.2 }}
          className='tw-text-center tw-mx-auto tw-max-w-md tw-text-sm tw-leading-snug tw-text-black/60 tw-h-[3lh]'
        >
          {defaultMessage}
        </m.p>
      )}
    </AnimatePresence>
  );
}
